import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "mode", "script"]

  apply(event) {
    const { mode, script, value } = event.params
    if (!this.validMode(mode) || !this.validScript(script) || typeof value !== "string") return

    this.modeTargets.forEach((radio) => {
      radio.checked = radio.value === mode
    })
    this.scriptTargets.forEach((radio) => {
      radio.checked = radio.value === script
    })

    this.inputTarget.value = value
    this.inputTarget.focus()
    this.inputTarget.selectionStart = value.length
    this.inputTarget.selectionEnd = value.length
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  validMode(mode) {
    return ["encode", "decode"].includes(mode)
  }

  validScript(script) {
    return ["latin", "kana"].includes(script)
  }
}
